import {Injectable} from '@angular/core';
import {QueryEntity} from '@datorama/akita';
import {PressState, Store} from './store';

@Injectable({ providedIn: 'root' })
export class PressQuery extends QueryEntity<PressState> {

  constructor(protected store: Store) {
    super(store);
  }

}
